import { create } from 'zustand';
import profileService from '../api/services/profile.service';
import useContextStore from './useContextStore';
import { showToast } from './useToastStore';

/* The logged-in room parent, fetched from /roomParentAdmin/myProfile right after
   login and on every reload while a token exists. `me` is the full user object;
   user_metadata.schoolClassDetails drives the dynamic context switcher. */
const useMyProfileStore = create((set, get) => ({
  me: null,
  loading: false,
  loaded: false,

  fetchMyProfile: async () => {
    if (get().loading) return;
    set({ loading: true });
    try {
      const res = await profileService.myProfile();
      const user = res?.data?.user || res?.user || null;
      set({ me: user });
      const schools = user?.user_metadata?.schoolClassDetails;
      if (Array.isArray(schools) && schools.length) {
        useContextStore.getState().setFromSchools(schools);
      }
    } catch (err) {
      showToast(err.message);
    } finally {
      set({ loading: false, loaded: true });
    }
  },

  reset: () => set({ me: null, loading: false, loaded: false }),
}));

export const selectMyMetadata = (s) => s.me?.user_metadata || null;

/* Profile loaded fine but the account has no school/class assigned — the app
   shows an explicit empty state. A failed fetch leaves no contexts at all, which
   AppLayout treats the same way; there is no demo data to fall back on. */
export const selectNoSchoolAssigned = (s) =>
  s.loaded && !!s.me && !(s.me.user_metadata?.schoolClassDetails?.length);

export default useMyProfileStore;
